import LastTransactionPanel from "./lastTransactionPanel.container";

export default LastTransactionPanel;
